import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Container, Row } from 'react-bootstrap';
import LogoComponent from '../Logo/LogoComponent';
import { apiUrl } from '../../utils/consts';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import BenefitCard from '../BenefitCard/BenefitCard';
import { couponBenefits } from '../../utils/couponCategories';
import helpImg from '../../img/ayudaIcono.png';
import helpImg2 from '../../img/ayudaIcono2.png';
import solicitarImg from '../../img/solicitarIcono.svg';
import solicitarImg2 from '../../img/solicitarIcono2.svg';
import RequestedBenefitCard from '../RequestedBenefitCard/RequestedBenefitCard';
import BenefitApplicationCard from '../BenefitApplicationCard/BenefitApplicationCard';
import RequestedBenefitModal from '../RequestedBenefitModal/RequestedBenefitModal';
import {
  setShowCreateModal,
  setShowRequestedBenefitModal,
} from '../../redux/modules/show';
import { connect } from 'react-redux';
import bannerImg from '../../img/background.jpg';
import CreatableSelect from 'react-select/creatable';
import queryString from 'query-string';
import './styles/benefits.scss';

function mapDispatchToProps(dispatch) {
  return {
    setShowCreateModal: (show) => dispatch(setShowCreateModal(show)),
    setShowRequestedBenefitModal: (show) =>
      dispatch(setShowRequestedBenefitModal(show)),
  };
}

const benefitTypeOptions = [
  { type: 'BENEFIT_TYPE', value: 'CUSTOM', label: 'Particular' },
  { type: 'BENEFIT_TYPE', value: 'COUPON', label: 'Bonos' },
];

function ConnectedBenefitsComponent(props) {
  const values = queryString.parse(props.location.search);
  const requestedBenefitId = values.id;

  const [benefits, setBenefits] = useState([]);
  const [benefitRequests, setBenefitRequests] = useState([]);
  const [selectedRequestedBenefit, setSelectedRequestedBenefit] =
    useState();
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(values.tab ? parseInt(values.tab) : 0);
  const [citiesValue, setCitiesValue] = useState('');
  const [cities, setCities] = useState([]);
  const [benefitTypeExpanded, setBenefitTypeExpanded] = useState(true);
  const [benefitTypes, setBenefitTypes] = useState([]);

  const filteredBenefits = benefits.filter((item) => {
    const typeFilterIndex = benefitTypes.findIndex(
      (type) => type.value === item.benefitType
    );
    const typeFilter = benefitTypes.length === 0 || typeFilterIndex !== -1;

    let citiesFilter =
      item.benefitType === 'COUPON' || !cities || cities.length === 0;

    if (!citiesFilter) {
      const filterCityArr = cities.map((city) => city.value);
      const location = item.location
        .trim()
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      const intersection = filterCityArr.findIndex(
        (city) => location.includes(city) || city.includes(location)
      );

      citiesFilter = intersection != -1;
    }

    return typeFilter && citiesFilter;
  });

  const filteredRequestedBenefits = benefitRequests.filter((item) => {
    const typeFilterIndex = benefitTypes.findIndex(
      (type) =>
        (type.value === 'CUSTOM' &&
          item.benefitFilterType === 'BENEFIT_REQUEST') ||
        (type.value === 'COUPON' &&
          item.benefitFilterType === 'BENEFIT_APPLICATION')
    );
    const typeFilter = benefitTypes.length === 0 || typeFilterIndex !== -1;

    let citiesFilter =
      item.benefitFilterType === 'BENEFIT_APPLICATION' ||
      !cities ||
      cities.length === 0;

    if (!citiesFilter) {
      const filterCityArr = cities.map((city) => city.value);
      const location = item.location
        .trim()
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      const intersection = filterCityArr.findIndex(
        (city) => location.includes(city) || city.includes(location)
      );

      citiesFilter = intersection != -1;
    }

    return typeFilter && citiesFilter;
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (requestedBenefitId && benefitRequests) {
      benefitRequests.forEach((item) => {
        if (
          item.benefitFilterType === 'BENEFIT_REQUEST' &&
          item._id === requestedBenefitId
        ) {
          setSelectedRequestedBenefit(item);
        }
      });
    }
  }, [benefitRequests]);

  useEffect(() => {
    if (selectedRequestedBenefit)
      props.setShowRequestedBenefitModal({ show: true });
  }, [selectedRequestedBenefit]);

  const fetchData = async () => {
    const benefitsProm = await fetch(`${apiUrl}/benefits/get`);
    const benefitsResp = await benefitsProm.json();

    if (benefitsResp.success) {
      setBenefits(benefitsResp.benefits.sort(() => 0.5 - Math.random()));
      setBenefitRequests(
        benefitsResp.benefitsRequested
          .concat(benefitsResp.benefitApplications)
          .sort(() => 0.5 - Math.random())
      );
    }

    setLoading(false);
  };

  const createBenefit = () => {
    props.setShowCreateModal({
      show: true,
      createModalTab: tab === 1 ? 1 : 2,
      hideTabs: true,
    });
  };

  const removeAllFilters = () => {
    setBenefitTypes([]);
    setCitiesValue('');
    setCities([]);
  };

  const handleCityChange = (value) => {
    setCities(value);
  };

  const handleInputCityChange = (value) => {
    setCitiesValue(value);
  };

  const createOption = (label) => ({
    label,
    value: label
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, ''),
  });

  const handleTypeFilterChange = (filterValue) => {
    const foundFilter = benefitTypes.find(
      (item) =>
        item.type === filterValue.type && item.value === filterValue.value
    );

    if (foundFilter) {
      setBenefitTypes(
        benefitTypes.filter(
          (item) =>
            item.value !== foundFilter.value ||
            item.type !== foundFilter.type
        )
      );
    } else {
      setBenefitTypes(benefitTypes.concat(filterValue));
    }
  };

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (citiesValue) {
          setCities([...cities, createOption(citiesValue)]);
          setCitiesValue('');
        }

        event.preventDefault();

        break;
      default:
        return;
    }
  };

  return (
    <div className='benefits-component'>
      <div
        className='app-banner'
        style={{ backgroundImage: `url("${bannerImg}")` }}>
        <LogoComponent />
        <h1 className='title'>{/* Muro de la solidaridad */}</h1>
        <div style={{ marginTop: '10vh' }}>
          <div className='nav-options'>
            <div style={{ display: 'inline-block' }}>
              <div
                className={`app-nav-button ${tab === 0 ? 'active' : ''}`}
                onClick={() => setTab(0)}
                style={{
                  borderTopRightRadius: '0',
                  borderBottomRightRadius: '0',
                }}>
                <img src={tab === 0 ? solicitarImg2 : solicitarImg} />
                <span>Quiero recibir ayuda</span>
              </div>
            </div>
            <div style={{ display: 'inline-block' }}>
              <div
                className={`app-nav-button ${tab === 1 ? 'active' : ''}`}
                onClick={() => setTab(1)}
                style={{
                  borderTopLeftRadius: '0',
                  borderBottomLeftRadius: '0',
                }}>
                <img src={tab === 1 ? helpImg2 : helpImg} />
                <span>Quiero ayudar</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Container
        fluid
        className='app-list-container'
        style={{
          marginTop: 0,
          marginBottom: '25px',
          borderBottom: 'none',
        }}>
        <Row noGutters>
          <Col xs={12}>
            {tab === 0 ? (
              <div
                style={{
                  margin: '15px 50px 10px',
                  textAlign: 'center',
                  color: '#072450',
                  fontSize: '1.2rem',
                }}>
                En esta sección puedes navegar por las ayudas que ofrecen
                las personas de tu comunidad. También puedes crear nuevas
                ofertas para quienes lo necesitan, dando clic en el botón
                Crear.
              </div>
            ) : (
              <div
                style={{
                  margin: '15px 50px 10px',
                  textAlign: 'center',
                  color: '#072450',
                  fontSize: '1.2rem',
                }}>
                En esta sección puedes encontrar las necesidades que tienen
                personas en tu comunidad y ayudarlas. También puedes
                publicar tu propia necesidad dando clic en el botón Crear.
              </div>
            )}
          </Col>
          <Col md={12}>
            <Button
              className='app-button create-benefit-btn'
              onClick={createBenefit}>
              <i className='fas fa-plus' /> Crear
            </Button>
          </Col>
        </Row>
      </Container>
      <Container
        fluid
        className='app-list-container'
        style={{ marginTop: 0 }}>
        <Row noGutters>
          <Col md={2}>
            <div className='filterSidebar'>
              <div style={{ marginBottom: '20px' }}>
                <span className='filterTitle'>Filtra por:</span>
                <span
                  className='removeFiltersBtn'
                  onClick={removeAllFilters}>
                  Quitar filtros
                </span>
              </div>

              <div
                className='filterSidebarTitle'
                style={{ cursor: 'default' }}>
                <span>Ciudad</span>
              </div>

              <CreatableSelect
                components={{ DropdownIndicator: null }}
                inputValue={citiesValue}
                onChange={handleCityChange}
                onInputChange={handleInputCityChange}
                onKeyDown={handleKeyDown}
                placeholder='Escribe una ciudad y coloca enter...'
                value={cities}
                menuIsOpen={false}
                isMulti
                isClearable
              />

              <div
                className='filterSidebarTitle'
                onClick={() =>
                  setBenefitTypeExpanded(!benefitTypeExpanded)
                }>
                <span>Tipo</span>
                <i
                  className={
                    benefitTypeExpanded
                      ? 'fas fa-chevron-down'
                      : 'fas fa-chevron-right'
                  }
                />
              </div>
              {benefitTypeExpanded &&
                benefitTypeOptions.map((item, index) => (
                  <Form.Check
                    key={index}
                    type='checkbox'
                    id={`type-${item.value}`}
                    label={item.label}
                    checked={
                      benefitTypes.findIndex(
                        (checkedType) => checkedType.value === item.value
                      ) !== -1
                    }
                    onChange={() => handleTypeFilterChange(item)}
                  />
                ))}
            </div>
          </Col>
          <Col md={10}>
            <div className='results-column'>
              {loading ? (
                <AppSpinner />
              ) : tab === 0 ? (
                <Row>
                  {filteredBenefits.map((item) => (
                    <Col
                      sm={4}
                      key={item._id}>
                      {item.benefitType === 'CUSTOM' ? (
                        <BenefitCard benefit={item} />
                      ) : (
                        <BenefitCard
                          benefit={couponBenefits.find(
                            (it) => it.id === item.category
                          )}
                          benefitId={item._id}
                        />
                      )}
                    </Col>
                  ))}
                </Row>
              ) : (
                <Row>
                  {console.log(filteredRequestedBenefits)}
                  {filteredRequestedBenefits.map((item) => (
                    <Col
                      sm={4}
                      key={item._id}>
                      {item.benefitFilterType === 'BENEFIT_REQUEST' ? (
                        <RequestedBenefitCard
                          benefit={item}
                          onClick={() => setSelectedRequestedBenefit(item)}
                        />
                      ) : (
                        <BenefitApplicationCard
                          item={item}
                          category={item.category}
                          userName={
                            !item.anonymousRequest
                              ? `${item.userFirstName} ${item.userLastName}`
                              : ''
                          }
                          priority={item.priority}
                          thumbnail={item.thumbnail}
                          id={item._id}
                        />
                      )}
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <RequestedBenefitModal
        benefit={selectedRequestedBenefit}
        onClose={() => setSelectedRequestedBenefit()}
      />
    </div>
  );
}

const BenefitsComponent = connect(
  null,
  mapDispatchToProps
)(ConnectedBenefitsComponent);

export default BenefitsComponent;
